import React from 'react';


import login from './pages/login/index';
import register from './pages/login/register';


import homeIndex from './pages/home';
import businessIndex from './pages/business';
import fqa from './pages/fqa';


import goodsList from './pages/goods/list';
import goodsDetail from './pages/goods/detail';


import cart from './pages/cart/list';
import cartSubmit from './pages/cart/submit';


import purchase from './pages/user/purchase/index';
import quote from './pages/user/purchase/quote';
import quoteCheck from './pages/user/purchase/quoteCheck';
import quoteSubmit from './pages/user/purchase/quoteSubmit';


import order from './pages/user/order/index';
import orderCheckSend from './pages/user/order/checkSend';
import orderSubmit from './pages/user/order/orderSubmit';
import logistics from './pages/user/order/logistics';


import device from './pages/user/device/index';
import project from './pages/user/project/index';
import msg from './pages/user/msg/index';


import info from './pages/user/info/index';
import password from './pages/user/info/password';
import address from './pages/user/info/address/index';
import invoice from './pages/user/info/invoice/index';
import saleOrder from './pages/user/saleOrder/index';


export default [
  {title: '', path: '/', component: homeIndex},
  {title: '', path: '/home', component: homeIndex},
  {title: '', path: '/business', component: businessIndex},
  {title: '', path: '/fqa', component: fqa},
  {title: '', path: '/login', component: login},
  {title: '', path: '/register', component: register},
  {
    title: '商品列表', path: '/goods', hidden: true, child: [
      {title: '', path: '/goods', component: goodsList},
      {title: '商品详情', path: '/goods/detail', component: goodsDetail},
    ]
  },
  {
    title: '', path: '/cart', child: [
      {title: '我的购物车', path: '/cart', component: cart},
      {title: '提交求购单', path: '/cart/submit', component: cartSubmit},
    ]
  },
  {
    icon: '', title: '在线求购', path: '/user/purchase', child: [
      {title: '我的求购记录', path: '/user/purchase', component: purchase},
      {title: '我的报价单', path: '/user/quote', component: quote},
      {title: '我的报价单', path: '/user/quote/check', component: quoteCheck, hidden: true},
      {title: '我的报价单', path: '/user/quote/submit', component: quoteSubmit, hidden: true},
    ]
  },
  {
    icon: '', title: '交易记录', path: '/user/order', child: [
      {title: '我的订单', path: '/user/order', component: saleOrder},
      // {title: '我的订单', path: '/user/order', component: order},
      // {title: '我的订单', path: '/user/order/send', component: orderCheckSend, hidden: true},
      // {title: '我的订单', path: '/user/order/submit', component: orderSubmit, hidden: true},
      // {title: '我的订单', path: '/user/order/logistics', component: logistics, hidden: true},
    ]
  },
  {
    icon: '', title: '我的管理', path: '/user/project', child: [
      {title: '项目管理', path: '/user/project', component: project},
      {title: '采买设备', path: '/user/device/Sale', component: device},
      {title: '租赁设备', path: '/user/device/Rent', component: device},
      {title: '仓储设备', path: '/user/device/Store', component: device},
      // {title: '服务提醒', path: '/user/msg', component: msg},

    ]
  },
  {
    icon: '', title: '系统设置', path: '/user/info', child: [
      {title: '完善个人信息', path: '/user/info', component: info},
      // {title: '修改密码', path: '/user/password', component: password},
      // {title: '收货地址', path: '/user/address', component: address},
      // {title: '发票信息', path: '/user/invoice', component: invoice},
    ]
  },
]
